import { render, staticRenderFns } from "./details.vue?vue&type=template&id=f7adcdd4&scoped=true&lang=pug&"
import script from "./details.vue?vue&type=script&lang=coffee&"
export * from "./details.vue?vue&type=script&lang=coffee&"
import style0 from "./details.vue?vue&type=style&index=0&id=f7adcdd4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7adcdd4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpBlocksLogoGallery: require('/opt/build/repo/nuxt-app/components/pages/pdp/blocks/logo-gallery.vue').default,ResponsiveCraftVisual: require('/opt/build/repo/node_modules/@bkwld/cloak/components/responsive-craft-visual.vue').default,PdpBlocksTastingNotes: require('/opt/build/repo/nuxt-app/components/pages/pdp/blocks/tasting-notes.vue').default,BlocksSpacer: require('/opt/build/repo/nuxt-app/components/blocks/spacer.vue').default,PdpBlocksBundleNutritionList: require('/opt/build/repo/nuxt-app/components/pages/pdp/blocks/bundle/nutrition-list.vue').default,PdpBlocksNutritionTable: require('/opt/build/repo/nuxt-app/components/pages/pdp/blocks/nutrition-table.vue').default,AccordionPane: require('/opt/build/repo/library/components/globals/accordion/accordion-pane.vue').default,Wysiwyg: require('/opt/build/repo/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,BlocksFaqList: require('/opt/build/repo/nuxt-app/components/blocks/faq-list.vue').default,BlocksList: require('/opt/build/repo/nuxt-app/components/globals/blocks/list.vue').default,PdpBlocksReviews: require('/opt/build/repo/nuxt-app/components/pages/pdp/blocks/reviews.vue').default})
